import { action, thunkOn, thunk } from 'easy-peasy';

export default {
  data: null,
  setTooltipData: action((state, payload) => {
    state.data = payload;
  }),
  setTooltipDataFromValue: thunk((actions, payload, helpers) => {
    const { chartData } = helpers.getStoreState().app;
    const tooltipData = chartData.find(d => d.value === payload);

    if (tooltipData) {
      actions.setTooltipData(tooltipData);
    }
  }),
  onValueChange: thunkOn((_, storeActions) => storeActions.app.setValue, (actions, target) => {
    actions.setTooltipDataFromValue(target.payload);
  })
};
